var render = function render(){var _vm=this,_c=_vm._self._c;return _c('world-map',{attrs:{"data":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }